import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  locale$ = new BehaviorSubject('de-DE');
  constructor() {}

  locale = 'de-DE';

  setLanguage(locale: string) {
    this.locale$.next(locale);
  }
}
